/* =============================================================================
   reviews-carousel.js: the SupplierReviews carousel
   (app/components/home/funnel/SupplierReviews.tsx), vanilla, no dependencies.

   State is one number, the active page (useState(0)). go(index) wraps in both
   directions exactly as the component's `(index + n) % n` does:
     · "Previous reviews" → go(active - 1)   (page 1 → page 4)
     · "More reviews"     → go(active + 1)   (page 4 → page 1)
     · rule button i      → go(i)
   Each render mirrors what React writes:
     · page i active   → no `hidden` attribute, class SLIDE_ACTIVE
     · page i inactive → hidden="", class SLIDE_HIDDEN (display:none, so the
                         page's loading="lazy" portraits are not fetched)
     · rule button i   → aria-current="true|false", its bar RULE_ACTIVE/RULE_IDLE
   Native <button>s give Enter/Space and focus; the component adds no swipe,
   arrow keys, autoplay or focus moves, so neither does this file.

   Tailwind scans assets/*.js: every class set here is written out in full.
   ========================================================================== */
(function () {
  'use strict';

  var SLIDE_ACTIVE = 'grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4';
  var SLIDE_HIDDEN = 'hidden';
  var RULE_ACTIVE = 'block h-0.5 w-6 bg-accent';
  var RULE_IDLE = 'block h-0.5 w-6 bg-rule-strong';

  function init(root) {
    if (!root || root.__reviewsCarousel) return;
    var carousel = root.querySelector('[aria-roledescription="carousel"]');
    if (!carousel) return;

    var slides = [];
    for (var el = carousel.firstElementChild; el; el = el.nextElementSibling) {
      if (el.getAttribute('aria-roledescription') === 'slide') slides.push(el);
    }
    var n = slides.length;
    if (!n) return;

    var prev = root.querySelector('button[aria-label="Previous reviews"]');
    var next = root.querySelector('button[aria-label="More reviews"]');
    var rules = root.querySelectorAll('button[aria-current]');

    var active = 0;
    for (var s = 0; s < n; s += 1) {
      if (!slides[s].hasAttribute('hidden')) {
        active = s;
        break;
      }
    }

    function render() {
      for (var i = 0; i < n; i += 1) {
        var on = i === active;
        if (on) slides[i].removeAttribute('hidden');
        else slides[i].setAttribute('hidden', '');
        slides[i].className = on ? SLIDE_ACTIVE : SLIDE_HIDDEN;
      }
      for (var j = 0; j < rules.length; j += 1) {
        var current = j === active;
        rules[j].setAttribute('aria-current', current ? 'true' : 'false');
        var bar = rules[j].firstElementChild;
        if (bar) bar.className = current ? RULE_ACTIVE : RULE_IDLE;
      }
    }

    function go(index) {
      active = (index + n) % n;
      render();
    }

    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });
    Array.prototype.forEach.call(rules, function (button, index) {
      button.addEventListener('click', function () { go(index); });
    });

    root.__reviewsCarousel = true;
  }

  function boot() {
    init(document.getElementById('reviews'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: a re-rendered section arrives as fresh markup.
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (target && target.querySelector) init(target.querySelector('#reviews'));
  });
})();
